"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchFromUrl = exports.parseBlob = exports.parseReadableStream = exports.parseNodeStream = exports.selectCover = exports.IFileInfo = exports.ratingToStars = exports.orderTags = exports.parseFromTokenizer = exports.parseBuffer = exports.IChapter = exports.INativeTagDict = exports.ITag = exports.IOptions = exports.IAudioMetadata = exports.IPicture = void 0;
const initDebug = require("debug");
const mm = require("@tunein/music-metadata/dist/core");
const readable_web_to_node_stream_1 = require("readable-web-to-node-stream");
const debug = initDebug('music-metadata-browser:main');
var type_1 = require("@tunein/music-metadata/dist/type");
Object.defineProperty(exports, "IPicture", { enumerable: true, get: function () { return type_1.IPicture; } });
Object.defineProperty(exports, "IAudioMetadata", { enumerable: true, get: function () { return type_1.IAudioMetadata; } });
Object.defineProperty(exports, "IOptions", { enumerable: true, get: function () { return type_1.IOptions; } });
Object.defineProperty(exports, "ITag", { enumerable: true, get: function () { return type_1.ITag; } });
Object.defineProperty(exports, "INativeTagDict", { enumerable: true, get: function () { return type_1.INativeTagDict; } });
Object.defineProperty(exports, "IChapter", { enumerable: true, get: function () { return type_1.IChapter; } });
var core_1 = require("@tunein/music-metadata/dist/core");
Object.defineProperty(exports, "parseBuffer", { enumerable: true, get: function () { return core_1.parseBuffer; } });
Object.defineProperty(exports, "parseFromTokenizer", { enumerable: true, get: function () { return core_1.parseFromTokenizer; } });
Object.defineProperty(exports, "orderTags", { enumerable: true, get: function () { return core_1.orderTags; } });
Object.defineProperty(exports, "ratingToStars", { enumerable: true, get: function () { return core_1.ratingToStars; } });
Object.defineProperty(exports, "IFileInfo", { enumerable: true, get: function () { return core_1.IFileInfo; } });
Object.defineProperty(exports, "selectCover", { enumerable: true, get: function () { return core_1.selectCover; } });
/**
 * Parse audio Stream
 * @param stream - ReadableStream
 * @param contentType - MIME-Type
 * @param options - Parsing options
 * @returns Metadata
 */
exports.parseNodeStream = mm.parseStream;
/**
 * Parse Web API ReadableStream: https://developer.mozilla.org/en-US/docs/Web/API/ReadableStream
 * @param stream - ReadableStream (web stream according WTWG Streams Standard)
 * @param fileInfo FileInfo object or MIME-Type
 * @param options - Parsing options
 * @returns Metadata
 */
function parseReadableStream(stream, fileInfo, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const ns = new readable_web_to_node_stream_1.ReadableWebToNodeStream(stream);
        const res = yield (0, exports.parseNodeStream)(ns, typeof fileInfo === 'string' ? { mimeType: fileInfo } : fileInfo, options);
        yield ns.close();
        return res;
    });
}
exports.parseReadableStream = parseReadableStream;
/**
 * Parse Web API File
 * @param blob - Blob to parse
 * @param options - Parsing options
 * @returns Metadata
 */
function parseBlob(blob, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const fileInfo = { mimeType: blob.type, size: blob.size };
        if (blob instanceof File) {
            fileInfo.path = blob.name;
        }
        return parseReadableStream(blob.stream(), { mimeType: blob.type, size: blob.size }, options);
    });
}
exports.parseBlob = parseBlob;
/**
 * Parse fetched file, using the Web Fetch API
 * @param audioTrackUrl - URL to download the audio track from
 * @param options - Parsing options
 * @returns Metadata
 */
function fetchFromUrl(audioTrackUrl, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(audioTrackUrl);
        const fileInfo = {
            size: parseInt(response.headers.get('Content-Length'), 10),
            mimeType: response.headers.get('Content-Type')
        };
        if (response.ok) {
            if (response.body) {
                const res = yield this.parseReadableStream(response.body, fileInfo, options);
                debug('Closing HTTP-readable-stream...');
                if (!response.body.locked) { // Prevent error in Firefox
                    yield response.body.cancel();
                }
                debug('HTTP-readable-stream closed.');
                return res;
            }
            else {
                // Fall back on Blob
                return this.parseBlob(yield response.blob(), options);
            }
        }
        else {
            throw new Error(`HTTP error status=${response.status}: ${response.statusText}`);
        }
    });
}
exports.fetchFromUrl = fetchFromUrl;
//# sourceMappingURL=index.js.map